import * as constants from './constants';
import * as selectors from './selectors';
import * as actions from './actions';
import * as actionTypes from './actionTypes';
import reducer from './reducer';
import sagas from './sagas';
import PlainLayout from './components/PlainLayout';
import ErrorLayout from './components/ErrorLayout';
import DashboardLayout from './components/DashboardLayout';
import messages from './messages';
const components = {
    PlainLayout,
    ErrorLayout,
    DashboardLayout
};
export default {
    components,
    constants,
    messages,
    selectors,
    actions,
    reducer,
    sagas,
    actionTypes
};
